import React from "react";
import MultiSelctCheckboxDropdown from "../../../../components/CheckboxMultiselect";
import { IconButton } from "@mui/material";
import downArrowImg from "../../../../styles/svg/downArrow.svg";
import { useSelector } from "react-redux";
import { CustomButton } from "../../../../components/Button/Button";
import { useListViewColumnFilter } from "./hooks/useListViewColumnFilter";

const AssignColumnHeader = () => {
  const assignee = useSelector(
    (state) => state.listViewHeaderFilters.assigneeIds
  );
  const {
    anchorEl,
    handleClearFilter,
    handleClick,
    handleClose,
    handleSelectionChange,
    isPrimaryFilterActive,
    selectedItems,
  } = useListViewColumnFilter({
    filterKey: "assigneeFilter",
    resetKey: "search",
    parseSelectedItems: (item) =>
      item === "unassigned" ? "unassigned" : Number(item),
  });

  return (
    <>
      <CustomButton className="remove-default-button-style d-flex reset-btn">
        Assignee
        <IconButton onClick={handleClick}>
          <img src={downArrowImg} alt="arrow" />
        </IconButton>
      </CustomButton>
      <MultiSelctCheckboxDropdown
        items={assignee}
        selectedItems={selectedItems}
        onSelectionChange={handleSelectionChange}
        isButton={true}
        anchorEl={anchorEl}
        valueKey="user_id"
        renderDisplay={(item) => `${item?.first_name} ${item?.last_name}`}
        handleClose={handleClose}
        handleClearFilter={handleClearFilter}
        isShowUnassigned={true}
        searchAssignee={!isPrimaryFilterActive}
      />
    </>
  );
};

export default AssignColumnHeader;
